import { useLocation } from 'react-router-dom';

import ScheduleSkeleton from './skeletons/schedule-skeleton';
import LiveAccountSkeleton from './skeletons/live-account-skeleton';
import StudioSkeleton from './skeletons/studio-skeleton';
import RoleSkeleton from './skeletons/role-skeleton';
import DefaultSkeleton from './skeletons/default-skeleton';
import ReportingSkeleton from './skeletons/reporting-skeleton';
import UserSkeleton from './skeletons/user-skeleton';
import ApprovalRescheduleSkeleton from './skeletons/approval-request-skeleton';
import TargetSkeleton from './skeletons/target-skeleton';
import MonitoringSkeleton from './skeletons/monitoring-skeleton';
import ReportAttendanceSkeleton from './skeletons/report-attendance-skeleton';
import ReportAttendanceOperatorSkeleton from './skeletons/report-attendance-operator-skeleton';
import ScheduleRulesetSkeleton from './skeletons/schedule-ruleset-skeleton';

const DashboardSkeleton = () => {
  const { pathname } = useLocation();

  switch (pathname) {
    case '/':
      return <MonitoringSkeleton />;
    case '/schedule':
      return <ScheduleSkeleton />;
    case '/schedule/approval-reschedule':
      return <ApprovalRescheduleSkeleton />;
    case '/master-data/schedule-ruleset':
      return <ScheduleRulesetSkeleton />;
    case '/master-data/account-livestream':
      return <LiveAccountSkeleton />;
    case '/master-data/studio':
      return <StudioSkeleton />;
    case '/master-data/access':
      return <RoleSkeleton />;
    case '/master-data/user':
      return <UserSkeleton />;
    case '/achievement/reporting':
      return <ReportingSkeleton />;
    case '/achievement/target':
      return <TargetSkeleton />;
    case '/report/attendance':
      return <ReportAttendanceSkeleton />;
    case '/report/attendance/operator':
      return <ReportAttendanceOperatorSkeleton />;

    default:
      return <DefaultSkeleton />;
  }
};

export default DashboardSkeleton;
